export default {
  PERFORMANCE_START_DATE: 'PERFORMANCE_START_DATE',
  PERFORMANCE_END_DATE: 'PERFORMANCE_END_DATE',
  SUBMISSIONS_START_DATE: 'SUBMISSIONS_START_DATE',
  SUBMISSIONS_END_DATE: 'SUBMISSIONS_END_DATE',
};
